import React, { useEffect, useState } from 'react';
import { getDatabase, ref, set, onValue } from 'firebase/database';

const LamaritutkaSun = ({ isAdmin }) => {
  const [u9Data, setU9Data] = useState([]);
  const [u8Data, setU8Data] = useState([]);

  const [newU8Entry, setNewU8Entry] = useState({ player: '', jersey: '', team: '', speed: '' });
  const [newU9Entry, setNewU9Entry] = useState({ player: '', jersey: '', team: '', speed: '' });

  const [editingU9Entry, setEditingU9Entry] = useState(null);
  const [editingU8Entry, setEditingU8Entry] = useState(null);

  const tabs = ['U9 Ikäluokka','U8 Ikäluokka'];
  const [activeTab, setActiveTab] = useState(tabs[0]);

  useEffect(() => {
    const db = getDatabase();
    const u9Ref = ref(db, 'lamaritutka/sunnuntai/u9');
    const u8Ref = ref(db, 'lamaritutka/sunnuntai/u8');

    const unsubU9 = onValue(u9Ref, (snapshot) => setU9Data(snapshot.val() || []));
    const unsubU8 = onValue(u8Ref, (snapshot) => setU8Data(snapshot.val() || []));

    return () => {
      unsubU9();
      unsubU8();
    };
  }, []);

  const addU9Entry = () => {
    if (!newU9Entry.player || !newU9Entry.jersey || !newU9Entry.team || !newU9Entry.speed) return;

    const db = getDatabase();
    const refU9 = ref(db, 'lamaritutka/sunnuntai/u9');

    onValue(refU9, (snapshot) => {
      const existing = snapshot.val() || [];
      const updated = [...existing, { ...newU9Entry, speed: parseInt(newU9Entry.speed) }];
      set(refU9, updated);
      setNewU9Entry({ player: '', jersey: '', team: '', speed: '' });
    }, { onlyOnce: true });
  };

  const saveU9Edit = () => {
    const db = getDatabase();
    const refU9 = ref(db, 'lamaritutka/sunnuntai/u9');

    onValue(refU9, (snapshot) => {
      const existing = snapshot.val() || [];
      const updated = existing.map((entry) =>
        entry === editingU9Entry ? { ...newU9Entry, speed: parseInt(newU9Entry.speed) } : entry
      );
      set(refU9, updated);
      setEditingU9Entry(null);
      setNewU9Entry({ player: '', jersey: '', team: '', speed: '' });
    }, { onlyOnce: true });
  };

  const addU8Entry = () => {
    if (!newU8Entry.player || !newU8Entry.jersey || !newU8Entry.team || !newU8Entry.speed) return;

    const db = getDatabase();
    const refU8 = ref(db, 'lamaritutka/sunnuntai/u8');

    onValue(refU8, (snapshot) => {
      const existing = snapshot.val() || [];
      const updated = [...existing, { ...newU8Entry, speed: parseInt(newU8Entry.speed) }];
      set(refU8, updated);
      setNewU8Entry({ player: '', jersey: '', team: '', speed: '' });
    }, { onlyOnce: true });
  };

  const saveU8Edit = () => {
    const db = getDatabase();
    const refU8 = ref(db, 'lamaritutka/sunnuntai/u8');

    onValue(refU8, (snapshot) => {
      const existing = snapshot.val() || [];
      const updated = existing.map((entry) =>
        entry === editingU9Entry ? { ...newU8Entry, speed: parseInt(newU8Entry.speed) } : entry
      );
      set(refU8, updated);
      setEditingU8Entry(null);
      setNewU8Entry({ player: '', jersey: '', team: '', speed: '' });
    }, { onlyOnce: true });
  };

  const renderTable = (label, data, isU9 = true) => {
    const sorted = [...data].sort((a, b) => b.speed - a.speed).slice(0, 5);
  
    return (
      <div style={{ marginBottom: 40 }}>
        <h3>{label} Ikäluokka | Top 5</h3>
        <div className="ranking-table-lämäritutka-container">
          <table className="ranking-table-lämäritutka">
            <thead>
              <tr>
                <th>Sija</th>
                <th>Pelaaja</th>
                <th>Pelinro</th>
                <th>Joukkue</th>
                <th>Nopeus (km/h)</th>
                {isAdmin && <th></th>}
              </tr>
            </thead>
            <tbody>
              {sorted.length === 0 ? (
                <tr><td colSpan={isAdmin ? 6 : 5}>Ei vielä tuloksia</td></tr>
              ) : (
                sorted.map((entry, i) => (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    <td>{entry.player}</td>
                    <td>{entry.jersey}</td>
                    <td>{entry.team}</td>
                    <td>{entry.speed}</td>
                    {isAdmin && (
                      <td>
                        <button
                          style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 16 }}
                          onClick={() => {
                            if (isU9) {
                              setEditingU9Entry(entry);
                              setNewU9Entry(entry);
                            } else {
                              setEditingU8Entry(entry);
                              setNewU8Entry(entry);
                            }
                          }}
                        >
                          ✏️
                        </button>
                      </td>
                    )}
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  return (
    <div className="lamaritutka-wrapper">
      <h4 className="date-title">Sunnuntai 18.05.2025</h4>
      <hr />
      <h3>💥 Lämäri-kilpailu 💥</h3>
      
      <p style={{fontSize: '16px', paddingLeft:'5px'}}>Tule testaamaan, kuka laukaisee kovimmin! 🔥</p>
      <p style={{fontSize: '15px',paddingLeft:'5px'}}>4 laukausta vain 2€. Paras tulos jää taulukkoon!</p>
      <p style={{fontSize: '16px', paddingLeft:'5px'}}>Kolme parasta voittaa <strong>yllätyspalkinnon!</strong> 🎁 </p>
      

      {/* Tab navigation */}
      <div className="tab-container">
        <div
          className="highlight-slider"
          style={{
            transform: activeTab === tabs[0] ? 'translateX(0%)' : 'translateX(100%)',
          }}
        />
         {tabs.map((tab) => (
          <button
            key={tab}
            className={`U8-lohko-tab-button ${activeTab === tab ? 'active' : ''}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>
      {/* Tab content */}
      {activeTab === 'U8 Ikäluokka' && (
        <>
          {isAdmin && (
            <div className="lamaritutka-admin-form">
              <hr />
              <h4 className="lamaritutka-form-title">U8 | {editingU8Entry ? 'Muokkaa tulosta' : 'Lisää uusi tulos'}</h4>
              <div className="lamaritutka-input-row">
                <input className="lamaritutka-input" 
                placeholder="Pelaaja" 
                value={newU8Entry.player} 
                onChange={(e) => setNewU8Entry({ ...newU8Entry, player: e.target.value })} />
                <input className="lamaritutka-input" 
                placeholder="Pelinro" 
                value={newU8Entry.jersey} 
                onChange={(e) => setNewU8Entry({ ...newU8Entry, jersey: e.target.value })} />
              </div>
              <div className="lamaritutka-input-row">
                <input className="lamaritutka-input" 
                placeholder="Joukkue" value={newU8Entry.team} 
                onChange={(e) => setNewU8Entry({ ...newU8Entry, team: e.target.value })} />
                <input className="lamaritutka-input" type="number" placeholder="Nopeus" value={newU8Entry.speed} onChange={(e) => setNewU8Entry({ ...newU8Entry, speed: e.target.value })} />
              </div>
              <button className="lamaritutka-button" onClick={editingU8Entry ? saveU8Edit : addU8Entry}>
                {editingU8Entry ? 'Tallenna' : 'Lisää'}
              </button>
            </div>
          )}
          {renderTable('U8', u8Data, true)}
        </>
      )}

      {activeTab === 'U9 Ikäluokka' && (
        <>
          {isAdmin && (
            <div className="lamaritutka-admin-form">
              <hr />
              <h4 className="lamaritutka-form-title">U9 | {editingU9Entry ? 'Muokkaa tulosta' : 'Lisää uusi tulos'}</h4>
              <div className="lamaritutka-input-row">
                <input className="lamaritutka-input" placeholder="Pelaaja" value={newU9Entry.player} onChange={(e) => setNewU9Entry({ ...newU9Entry, player: e.target.value })} />
                <input className="lamaritutka-input" placeholder="Pelinro" value={newU9Entry.jersey} onChange={(e) => setNewU9Entry({ ...newU9Entry, jersey: e.target.value })} />
              </div>
              <div className="lamaritutka-input-row">
                <input className="lamaritutka-input" placeholder="Joukkue" value={newU9Entry.team} onChange={(e) => setNewU9Entry({ ...newU9Entry, team: e.target.value })} />
                <input className="lamaritutka-input" type="number" placeholder="Nopeus" value={newU9Entry.speed} onChange={(e) => setNewU9Entry({ ...newU9Entry, speed: e.target.value })} />
              </div>
              <button className="lamaritutka-button" onClick={editingU9Entry ? saveU9Edit : addU9Entry}>
                {editingU9Entry ? 'Tallenna' : 'Lisää'}
              </button>
            </div>
          )}
          {renderTable('U9', u9Data, true)}
        </>
      )}
    </div>

  );
};

export default LamaritutkaSun;
